/**
 * Module - Agent Management (angentManage)
 */
export default {
  // 直接作为根级属性，方便使用 $t('angentManage.xxx')
  angentManage: {
    chargePlan: 'Charge plan',
    organizationTag: 'Organization tag',
    textje8x: 'File Name',
    textd6a5: 'Size',
    fileStatus: 'File Status',
    remark: 'Remark',
    operator: 'Operator',
    operationTime: 'Operation Time',
    auto_106_06fe6a19: 'Collapse',
    auto_107_05456712: 'Expand',
    auto_108_00bbd0a1: 'AddSchool',
    auto_109_323176e9: 'pi liangLinked Campus',
    auto_110_0aba07e4: 'Edit',
    auto_111_3974910f: 'Linked Campus',
    auto_112_267ce3c2: 'Remove',
    auto_113_d0221b28: 'Tip',
    auto_114_3968fa67: 'shi fouConfirmRemove',
    auto_115_84ac5284: 'School Name',
    auto_116_60fb16eb: 'Enter School Name',
    auto_117_0a6559c0: 'SchoolProvince/City/District',
    auto_118_184bc002: 'School Section',
    auto_119_a311294f: 'Select schoolStage',
    auto_120_f64f7d06: 'School Nature',
    auto_121_cc0135ad: 'Please selectSchool Nature',
    auto_122_917d1b7f: 'Boarding Status',
    auto_124_d8413d4e: 'Linked Campus',
    auto_125_9a2afdd5: 'Select Campus',
    auto_126_bc008c75: 'Operation',
    auto_127_16f5a077: 'SchoolProvince/City/District',
    auto_128_fc20d700: 'School Name',
    auto_129_18e1f889: 'Enter School Name',
    auto_130_e9c403b6: 'School Address',
    auto_131_d0c268a5: 'Please fill inSchool Address',
    auto_132_c76481a7: 'Boarding Status',
    auto_133_880878f8: 'Please selectBoarding Status',
    auto_134_a68ce52e: 'School Section',
    auto_135_90100094: 'Select schoolStage',
    auto_136_56443e49: 'School Nature',
    auto_137_c5f37b51: 'Label',
    auto_138_7b608045: 'Schoolren shu',
    auto_139_7ac46c85: 'Enter schoolren shu',
    auto_140_bb775e75: 'Label',
    auto_141_ac4379b9: 'Enterban ji shu',
    auto_142_5dba9534: 'Schoolgai kuang',
    auto_143_c75e0f9e: 'Enter schoolgai kuang zui da1000zi',
    auto_144_5501bd34: 'Remark',
    auto_145_4ab32238: 'Enter remarkzui da500zi',
    auto_146_1b486b0e: 'Linked Campus',
    auto_147_48b76f6a: 'SelectCampus',
    auto_148_2719dc8a: 'Select Campus',
    auto_413_956e1a49: 'Select province/city/district',
    auto_414_b30f89a0: 'Clear filter',
    auto_415_dc6a8744: 'Select province/city/district',
    auto_416_189dea06: 'Please selectBoarding Status',
    auto_417_58a55c6c: 'School Name',
    auto_418_6704df9b: 'Province/City/District',
    auto_419_d52d4a56: 'Detail Address',
    auto_420_f5406573: 'Linked Campus',
    auto_421_9911cdfb: 'School Nature',
    auto_422_9ade080c: 'Stage',
    auto_423_c6c4edcb: 'Boarding Status',
    auto_424_d0081593: 'Schoolren shu',
    auto_425_60fb81c5: 'Label',
    auto_426_85fd567b: 'Schoolgai kuang',
    auto_427_ba866426: 'Remark',
    auto_428_8ae5cb3f: 'AddSchool',
    auto_429_e3d911f6: 'AddSchool',
    auto_430_72b510b7: 'EditSchool',
    auto_1_5dbea729: 'Add',
    auto_2_0f9a265f: 'Edit',
    auto_3_763058fc: 'Preview',
    auto_4_d3a7c313: 'On Shelf',
    auto_5_7f24f184: 'Off Shelf',
    auto_6_2ad7d5e1: 'AllCampus',
    auto_7_12a586c3: 'On Shelf',
    auto_7_6b74106c: 'bu fenCampus',
    auto_8_5dc14a75: 'Tip',
    auto_8_c9afae9d: 'Off Shelf',
    auto_9_729212dd: 'Operation',
    auto_9_ab9721fd: 'Select location',
    auto_10_acbcbf89: 'Ad Position',
    auto_11_4b1e5ce3: 'Select ad position',
    auto_12_98bf012e: 'Advertisement Name',
    auto_12_d7bddb28: 'Addguang gao',
    auto_13_8a858b9d: 'Label',
    auto_13_a12733c2: 'Enter ad name',
    auto_14_0232da13: 'Charge Status',
    auto_14_6f6fd7f3: 'Sort',
    auto_15_0e39805e: 'Label',
    auto_15_9197175c: 'CampusType',
    auto_16_0ae1cfe3: 'Sort',
    auto_16_dcebb3c9: 'Campusxing zhi',
    auto_17_02f830c2: 'Label',
    auto_17_796dbe36: 'guang gaoImage',
    auto_18_58acb097: 'Status',
    auto_18_5bcc86af: 'Advertisement Name',
    auto_19_8eda55dc: 'Displaytext',
    auto_19_b6477710: 'Ad Position',
    auto_20_17eb1ec8: 'Please select',
    auto_20_da93f628: 'Sort',
    auto_21_73e59cd4: 'Status',
    auto_21_92e4bdbe: 'Enter School Name',
    auto_22_0bd22920: 'Enter',
    auto_22_33a639ad: 'Last Edit Time',
    auto_23_151af6cf: 'Displaytext',
    auto_23_d183ba8a: 'Entertiao zhuanUrl',
    auto_24_3c3ec2fc: 'Label',
    auto_24_6b417098: 'Free',
    auto_25_5cad1762: 'Paid',
    auto_25_d6b4aa30: 'Entertiao zhuan lu you',
    auto_26_92c26f06: 'Select charge status',
    auto_26_bd20cad5: 'Preview',
    auto_27_a09266aa: 'Select CampusType',
    auto_28_c22fd1e2: 'Select campus nature',
    auto_29_30d327f2: 'Addguang gao',
    auto_30_a46e8acd: 'Editguang gao',
    auto_31_37a929ba: 'Please first SelectLocation',
    auto_32_5a22c5da: 'Save failed',
    auto_33_1b59b303: 'Editguang gao',
    auto_34_feeeffd2: 'On Shelf',
    auto_35_6b717bf8: 'Off Shelf',
    auto_36_ce0e6d8a: 'On Shelf',
    auto_37_15f0883a: 'Off Shelf',
    auto_152_559ac074: 'he tongType',
    auto_153_fd464748: 'ContractName',
    auto_154_67dd4068: 'Contract Code',
    auto_155_9160b8a0: 'ContractAmount',
    auto_156_42436328: 'he tong qian shuTime',
    auto_157_0cc00bfe: 'he tongStart Time',
    auto_158_298b8db7: 'he tong jie shuTime',
    auto_158_abbed0fc: 'Addhe tong',
    auto_159_3fbde64c: 'dang yueConfirmshou ruAmountyuan',
    auto_159_854956ba: 'Addhe tong',
    auto_160_33a7227b: 'Contract Manager',
    auto_160_bc9ed7a4: 'Upload Attachment',
    auto_161_3b87923a: 'Addxie yi',
    auto_161_3dabe5e1: 'Remark',
    auto_162_4859590f: 'Create Time',
    auto_162_6e1c61a4: 'Addxie yi',
    auto_163_0ba2d4de: 'Upload Attachment',
    auto_163_6f4e4ad4: 'Created By',
    auto_164_5848197c: 'LatestUpdate Time',
    auto_165_65f8c2d4: 'Modifier',
    auto_166_6234ffac: 'File Type',
    auto_167_5bdbf60b: 'File Purpose',
    auto_168_eb0b3a22: 'Fileqian shuTime',
    auto_169_6534851f: 'File Signing Manager',
    auto_170_2249f3d2: 'Remark',
    auto_171_c8ec6668: 'Create Time',
    auto_172_899e97aa: 'Created By',
    auto_173_143a4be9: 'LatestUpdate Time',
    auto_174_8117d26d: 'Modifier',
    auto_175_d8108f82: 'Label',
    auto_176_078cc1e3: 'Label',
    auto_177_0388c40f: 'zui da keUploaddeFile',
    auto_178_0649bd42: 'zui da keUploaddeFile',
    auto_179_fed75aa1: 'Edithe tongSuccess',
    auto_180_f808e435: 'Addhe tongSuccess',
    auto_181_8f0bfc96: 'Edithe tongFailed',
    auto_182_df277363: 'Addhe tongFailed',
    auto_183_09754d66: 'Editxie yiSuccess',
    auto_184_62c1fcf6: 'Addxie yiSuccess',
    auto_185_8997f4d1: 'Editxie yiFailed',
    auto_186_aae610db: 'Addxie yiFailed',
    auto_187_fe8e8977: 'Attachment',
    auto_188_e1e50f91: 'Attachment',
    auto_189_b7991d6e: 'Attachment',
    auto_190_8831129c: 'Attachment',
    auto_191_66d307f4: 'Attachment',
    auto_192_e9852cc0: 'Attachment',
    auto_193_0fd9f522: 'Deletehe tongSuccess',
    auto_194_a280b383: 'Deletehe tongFailed',
    auto_195_ed654bde: 'Deletexie yiSuccess',
    auto_196_a5439fb9: 'Deletexie yiFailed',
    auto_199_b9cd767c: 'CourseCancelAllocatehouCampusjiang bu neng baCourseAllocategeiStudent',
    auto_353_8383c1f0: 'Grade 1',
    auto_354_c2d99903: 'Grade 2',
    auto_355_ba246d86: 'Grade 3',
    auto_356_9ca95ecf: 'Grade 4',
    auto_357_90770fab: 'Grade 5',
    auto_358_e5eeeb38: 'Grade 6',
    auto_359_e7c47066: 'Grade 6',
    auto_360_76dffb5c: 'Grade 7',
    auto_361_4ed5342d: 'Grade 8',
    auto_362_8089c9b6: 'Grade 9',
    auto_363_45ebf10e: 'Grade 10',
    auto_364_a60888f1: 'Grade 11',
    auto_365_703cd7c2: 'Grade 12',
    auto_366_84c5194a: 'Grade 13',
    auto_367_6ce205f5: 'Course Name',
    auto_368_48455d5e: 'EnterCourse Name',
    auto_369_f0d466c7: 'Subject',
    auto_370_5f25d5c2: 'Select subject',
    auto_371_aad6f478: 'Stage/Grade',
    auto_372_b673709d: 'Please select',
    auto_373_4e512bf4: 'Stage/Grade',
    auto_374_254d311d: 'Please select',
    auto_375_e16a8fc6: 'Textbook Version',
    auto_376_16365df4: 'Please selectTextbook Version',
    auto_377_b78fc647: 'Type',
    auto_378_fd39ec5e: 'Please selectjiao caiType',
    auto_379_654494a8: 'Regular Course',
    auto_380_b96ce4af: 'Label',
    auto_381_260a1818: 'Assign Time',
    auto_382_6ed514db: 'Course Name',
    auto_383_6b6a4d82: 'Subject',
    auto_384_f610f707: 'Stage/Grade',
    auto_385_dea12717: 'Textbook Version',
    auto_386_68fb2999: 'Type',
    auto_387_a3514308: 'UpdateTime',
    auto_388_f12f16c2: 'Allocateren',
    auto_389_58847c02: 'Assign Time',
    auto_390_0824c363: 'Course Name',
    auto_391_df1375bd: 'Subject',
    auto_392_e75dc481: 'Stage/Grade',
    auto_393_de30e4b1: 'Textbook Version',
    auto_394_89e678a0: 'Type',
    auto_395_accfce0a: 'UpdateTime',
    auto_396_b226acd3: 'Allocateren',
    auto_397_38b5bdfb: 'Assign Time',
    auto_398_456329e2: 'Regular Course',
    auto_399_3543883b: 'Label',
    auto_49_d25b5fc6: 'Pricing & System Info',
    auto_50_ebebf68b: 'Free',
    auto_51_2b86a4f7: 'Paid',
    auto_52_978757e3: 'Enable',
    auto_53_f1d254ce: 'Enable Small Class',
    auto_54_0d07eafa: 'yuanClass Hours',
    auto_55_1188907f: 'yuanClass Hours',
    auto_56_68cfbc89: 'yuanClass Hours',
    auto_57_1007817c: 'yuanClass Hours',
    auto_58_9ead3a35: 'yuanClass Hours',
    auto_59_64eb1e8a: 'yuanClass Hours',
    auto_60_fa9e90c1: 'Enable Large Class',
    auto_61_b08c0397: 'yuanClass Hours',
    auto_62_2b70d7e8: 'yuanClass Hours',
    auto_63_f2f7f943: 'yuanClass Hours',
    auto_64_68f3e04f: 'Based onCampusgeStageding jia tong shi jie hePricing FactorCampusPaidhouPrimary SchoolStageshi jiPayment',
    auto_65_c32bba3f: '5yuanClass Hours',
    auto_67_91be6ec6: '6yuanClass Hours',
    auto_69_9e03b0e6: '7yuanClass Hours',
    auto_70_2d60ea96: 'Campusmian shou qi geStageshi jiPaymentwei',
    auto_71_c2b1eff9: '0yuanClass Hours',
    auto_72_6057cc4a: 'Pending Confirm',
    auto_73_00af2115: 'Label',
    auto_74_4769f257: 'Label',
    auto_75_ce4586eb: 'Participate',
    auto_76_a4855898: 'Not Participate',
    auto_77_33db3040: 'Verification',
    auto_78_4c22b5f8: 'Editing pricing and system information requires sending a verification code. Send now?',
    auto_79_5571ab4a: 'Output',
    auto_197_2627d43c: 'Please enter verification code',
    auto_198_3b1d3eb7: 'Verification code sent successfully',
    auto_199_3b783b70: 'Verification code send failed',
    auto_200_51684f52: 'Label',
    auto_201_4c816e56: 'Enterzi dongRechargekou kuan bi',
    auto_202_1c3a2e51: 'Label',
    auto_203_ad9868b4: 'Pricing & System InfoSavecheng',
    auto_204_6e97e4df: 'Pricing & System InfoSaveshi',
    auto_600166_6a425931: 'Junior HighStageshi jiPayment',
    auto_700168_6e3832b8: 'Senior HighStageshi fuPayment',
    auto_165_94efbea8: 'AddInitial Amount',
    auto_166_75b4048e: 'AddInitial Amount',
    auto_167_57991ebf: 'Gold Account',
    auto_168_e656828b: 'Upload Attachment',
    auto_205_adf76b23: 'Rechargeaccount',
    auto_206_f38cead2: 'Initial Amount',
    auto_207_f548cc9c: 'Payment Time',
    auto_208_f4e6d4be: 'Payfang shi',
    auto_209_237fa570: 'Pay Serial No.',
    auto_210_69c1fa1c: 'Remark',
    auto_211_ba13f205: 'Created By',
    auto_212_b4a20463: 'Create Time',
    auto_213_4b8d40e9: 'Last Updated By',
    auto_214_19608d29: 'Last Update Time',
    auto_215_17f69bfb: 'zui da keUploaddeFile',
    auto_216_01d50fd3: 'Label',
    auto_217_94b88df2: 'Label',
    auto_218_1b66f4e7: 'Label',
    auto_219_3cd02175: 'Label',
    auto_220_a79d6f7c: 'Label',
    auto_221_e747c7e6: 'Label',
    auto_222_0cbd246b: 'Label',
    auto_223_070cb023: 'Label',
    auto_224_58f35c2d: 'Label',
    auto_225_0d756fcd: 'Label',
    auto_226_4098fa8c: 'Label',
    auto_227_7377fca2: 'Label',
    auto_228_a30639f0: 'Label',
    auto_229_4819837a: 'Label',
    auto_230_fd4b256e: 'Label',
    auto_231_e53bbe6f: 'Label',
    auto_232_24b2d4a9: 'EditAgentInitialaccountjin',
    auto_233_7434df88: 'Saved successfully',
    auto_234_c284074b: 'shi fouContinue',
    auto_235_c7537d73: 'EditAgentInitialaccountjin',
    auto_236_0af6f5bb: 'Save failed',
    auto_237_87d7a5c4: 'Attachment',
    auto_238_72f71c15: 'DeleteAgentInitialaccountjin',
    auto_239_e268fb27: 'DeleteAgentInitialaccountjin',
    auto_27_ef3ce910: 'Account Info',
    auto_28_b5eb70e1: 'AddAccount',
    auto_29_79eb76fb: 'Reset Password',
    auto_30_1962cee5: 'Label',
    auto_31_fa023517: 'DisableAccount',
    auto_32_f00f9205: 'chong xinEnable',
    auto_33_b47d9a4f: 'she zhi wei pu tongAccount',
    auto_34_62374bc9: 'Sendduan xin',
    auto_35_0f2e8708: 'textagentsongshuaicomtext',
    auto_36_76937eb2: 'Label',
    auto_37_7488bdd5: 'biao ji wei pu tongAccounthou jiang wu fa congAgentdang an guan li gaiAccount',
    auto_38_4eb38d0f: 'gaiIDxia de zhuAccountreng ke yiPassedAgentDealer systemguan li gaiAccount',
    auto_49_d4dacb31: 'Sendyao yue duan xin',
    auto_50_59c5a166: 'Label',
    auto_51_b2642af0: 'Label',
    auto_52_1f6a60ae: 'Label',
    auto_53_67fdf4be: 'Copied successfully',
    auto_54_3fe737f2: 'Disable successful',
    auto_55_d5ce9126: 'DisableFailed',
    auto_56_5fde9fe9: 'Enable successful',
    auto_57_37d1f6d9: 'Failed to enable account',
    auto_58_3c2f1e16: 'Failed to enable account',
    auto_59_bff29c3c: 'she zhiSuccess',
    auto_60_400460b0: 'she zhiFailed',
    auto_61_7684c8f7: 'Account edited successfully',
    auto_62_7140b72f: 'Failed to edit account',
    auto_63_5cd2fd4e: 'Label',
    auto_64_27ef51b4: 'Account added successfully',
    auto_65_bd54cc4e: 'Failed to add account',
    auto_66_9c97237c: 'duan xinSent successfully',
    auto_92_cc1166cc: 'Backnbspnbsp',
    auto_93_6a436830: 'Campusdang an',
    auto_94_5928a2d4: 'Account Info',
    auto_95_2439e57d: 'ContactInformation',
    auto_96_ed64406c: 'Label',
    auto_97_6b0b9cf9: 'HQ Leads Plan',
    auto_98_d8f65d8c: 'Pre-Kke',
    auto_99_aed51598: 'K2ke',
    auto_100_04cd98c2: 'Pre-Kke',
    auto_101_a22a83ec: 'Basic Info',
    auto_102_d0f0f776: 'ipAddress',
    auto_103_b6d110da: 'Device Info',
    auto_104_ad632e46: 'Collapse',
    auto_105_ef54ff00: 'Expand',
    auto_400_4139981b: 'EditCampus',
    auto_401_85ef36f0: 'Pending Confirm',
    auto_402_40941d70: 'Label',
    auto_403_a698454c: 'Label',
    auto_404_53219907: 'Enable',
    auto_405_8e498bd1: 'Close',
    auto_406_ea4105e4: 'Participate',
    auto_407_4d380faa: 'Not Participate',
    auto_408_14fc3601: 'Formal Handoverhe zuo xiao',
    auto_409_afd388ce: 'Label',
    auto_410_901c0027: 'Not Renovated',
    auto_411_4608f461: 'Renovating',
    auto_412_debd3c0e: 'Renovation Done',
    auto_80_80315819: 'Backnbspnbsp',
    auto_81_fd6ec8e0: 'Organization ID',
    auto_82_33a82215: 'nbspExpand',
    auto_83_d4dbf580: '3nonenbspCollapse',
    auto_84_384732d9: 'Rentnian',
    auto_85_8e060283: 'Rentyue',
    auto_86_c15acb83: 'iPAddress',
    auto_87_3d415ccd: 'Account NameUnit Name',
    auto_88_51d772a9: 'iDAttendance Machine',
    auto_89_5904a7f9: 'HQ Leads Plan',
    auto_90_741a9603: 'Claim LimitDaily',
    auto_91_7f527a0c: 'Phone NumberViewshang xianDaily',
    auto_249_3c59bc76: 'Formal Handover',
    auto_250_f8314491: 'Pre-Handover',
    auto_251_fd79d25c: 'Not Renovated',
    auto_252_ae0e51a3: 'Renovating',
    auto_253_605fdfb4: 'Renovation Done',
    auto_254_ea555d8c: 'Individual',
    auto_255_02a1a74f: 'Company',
    auto_256_20af1c41: 'Paid',
    auto_257_ea9be41f: 'Free',
    auto_258_0d75af8b: 'Enable',
    auto_259_2cd21d0c: 'Close',
    auto_260_6e13beb2: 'Participate',
    auto_261_27fd171d: 'Not Participate',
    auto_262_2206ea1f: 'Material',
    auto_126_a81a7420: 'UploadBusiness License',
    auto_127_f7c3dcc9: 'Select location',
    auto_128_c311c9f7: 'Please selectContract Manager',
    auto_129_11b39a48: 'Please selectTMK Staff',
    auto_130_b94d4abc: 'Campus',
    auto_131_e260471b: 'Signing EntityType',
    auto_132_bcf7c0dc: 'SignName',
    auto_133_f97f507d: 'Label',
    auto_134_3753c507: 'Sign Entity Name',
    auto_135_744428fc: 'Change Reason',
    auto_136_8da52131: 'Company',
    auto_137_2afbac64: 'EnterSign Entity Name',
    auto_138_57f014e9: 'Enterqian yue renName',
    auto_139_d182fb77: 'Label',
    auto_140_de3ad287: 'Customer Name',
    auto_141_23569328: 'Referrer',
    auto_142_afe681e4: 'ReferrerName',
    auto_143_0eff35dd: 'Label',
    auto_144_0ffa9bc6: 'Label',
    auto_145_6f9d79e2: 'Label',
    auto_146_9d4ad26a: 'Label',
    auto_147_d7b82912: 'Label',
    auto_148_fc1ee04e: 'Contract Basic InfoSaved successfully',
    auto_149_3ff4a0bc: 'Contract Basic InfoSave failed',
    auto_151_b2cb1fca: 'Business License',
    auto_297_3d78ec77: 'Regular Course',
    auto_298_f333a8c9: 'Label',
    auto_299_a8f3aa43: 'Course Name',
    auto_300_4312ad23: 'Subject',
    auto_301_7da2fccf: 'Stage/Grade',
    auto_302_1b1e015d: 'Textbook Version',
    auto_303_d7f7b6fe: 'Type',
    auto_304_7e38397a: 'UpdateTime',
    auto_305_47aaac0f: 'Grade 1',
    auto_306_0241ea6e: 'Grade 2',
    auto_307_74198474: 'Grade 3',
    auto_308_224610c8: 'Grade 4',
    auto_309_7b55e318: 'Grade 5',
    auto_310_9509e3db: 'Grade 6',
    auto_311_fb8d2453: 'Grade 6',
    auto_312_37ee9746: 'Grade 7',
    auto_313_cb06ad6c: 'Grade 8',
    auto_314_e458a0da: 'Grade 9',
    auto_315_fc9c5788: 'Grade 10',
    auto_316_7b2210ea: 'Grade 11',
    auto_317_2e0f0e6d: 'Grade 12',
    auto_318_beb4ebc6: 'Grade 13',
    auto_97_d7b966c9: 'Invoice Type',
    auto_98_30edec66: 'Invoice Amount',
    auto_99_468c6b0e: 'Invoice Title',
    auto_100_aa26659d: 'invoiceTax No.',
    auto_101_4decc61e: 'Invoice Date',
    auto_102_eaefd8a1: 'zui da keUploaddeFile',
    auto_103_8f8acc83: 'EditinvoiceSuccess',
    auto_104_135f847f: 'AddSuccess',
    auto_105_455dce85: 'EditinvoiceFailed',
    auto_106_35e509fa: 'AddSuccess',
    auto_107_ebfbf351: 'Attachment',
    auto_108_b8d95cea: 'Attachment',
    auto_109_b6abcf50: 'Attachment',
    auto_110_c7ff7093: 'DeleteinvoiceSuccess',
    auto_111_e4fb0137: 'DeleteinvoiceFailed',
    auto_177_bc3e76a9: '0noneshi fou yiDraw Invoice',
    auto_178_12a68c31: 'Addinvoice',
    auto_179_1458572d: 'Uploadinvoice',
    auto_180_7e29bdbd: 'ConfirmDeletema',
    auto_67_a40888fd: 'Normal',
    auto_68_5ee7ba55: 'Close',
    auto_69_3fd38855: 'sheng chengCampusSuccess',
    auto_70_9312017b: 'ContractInformationSubmithou ke sheng cheng',
    auto_71_e4fae474: 'sheng cheng xiaoSongshuCampusSuccess',
    auto_72_94662f3c: 'Gen Failed',
    auto_73_d01e6f52: 'Label',
    auto_74_54000a2d: 'Campus Basic InfoSaved successfully',
    auto_75_8bc7f4bc: 'Campus Basic InfoSave failed',
    auto_149_f112d9ae: 'Campus Basic Info',
    auto_150_ef222d81: 'Not Renovated',
    auto_151_6353753e: 'Renovating',
    auto_152_5a2c1f9e: 'Renovation Done',
    auto_153_1b7ef83a: 'AddInvoice Info',
    auto_154_266681a5: 'AddIPAddress',
    auto_155_02a34ead: 'AddReturnaccount',
    auto_156_07401cd4: 'Confirmsheng chengCampus ID',
    auto_157_395c1a99: 'Output',
    auto_39_d4d845e5: 'Campus Entity',
    auto_40_b5326075: 'sheng chengCampus ID',
    auto_41_f9d88f13: 'sheng cheng xiaoSongshuqian yue xiaoID',
    auto_42_27271d63: 'Label',
    auto_44_2fb2a6d0: 'Pre-Handover',
    auto_45_470f69eb: 'Formal Handover',
    auto_46_47998950: 'Confirmsheng chengCampus ID',
    auto_47_f4993908: 'Confirmsheng cheng xiaoSongshuqian yue xiaoID',
    auto_48_0884dd73: 'Output',
    auto_88_ac1f843b: 'Normal',
    auto_89_9c4bd968: 'Close',
    auto_90_5e50bfd4: 'sheng chengCampusSuccess',
    auto_91_54d8a895: 'ContractInformationSubmithou ke sheng cheng',
    auto_92_d175ebd4: 'sheng cheng xiaoSongshuCampusSuccess',
    auto_93_105156b7: 'Gen Failed',
    auto_94_bc6dfd15: 'Label',
    auto_95_39c76cf4: 'Campus EntitySaved successfully',
    auto_96_200716b1: 'Campus EntitySave failed',
    auto_336_badae22e: 'Add',
    auto_337_b94fcb4a: 'Edit',
    auto_338_86e27584: 'Payment Userzheng ming',
    auto_339_1e3a509e: 'Payment Userzheng ming',
    auto_340_73b27d0e: 'AttachmentDetail',
    auto_341_21dd0b8f: 'Payment Userzheng ming',
    auto_342_0b66c93f: 'Payment Userzheng ming',
    auto_343_77bb1515: 'AttachmentDetail',
    auto_344_33cbbb5c: 'Delete',
    auto_345_376f08f3: 'Payment Userzheng ming',
    auto_346_03a57dbb: 'Payment Userzheng ming',
    auto_347_84a8893b: 'AttachmentDetail',
    auto_348_71e39444: 'Label',
    auto_349_8314398e: 'bian gengTime',
    auto_350_0d085309: 'Label',
    auto_351_7b267482: 'Change Type',
    auto_352_76d35af0: 'textcharacterstext',
    auto_76_d68665de: 'Material Type',
    auto_77_e56bfe62: 'Material Name',
    auto_78_293f550e: 'Remark',
    auto_79_8bce55d1: 'UploadTime',
    auto_80_cbfa2138: 'Uploader',
    auto_81_02076d0d: 'zui da keUploaddeFile',
    auto_82_a14fb41f: 'Attachment',
    auto_83_b642f3dd: 'Attachment',
    auto_84_9632590e: 'Material added successfully',
    auto_85_f0e3dd3d: 'Add material failed',
    auto_86_9d561389: 'Delete info successful',
    auto_87_2d4639f5: 'Delete material failed',
    auto_173_3b6b8858: 'AddMaterial',
    auto_174_64a0383b: 'AddMaterial',
    auto_175_58ae8382: 'Upload Attachment',
    auto_176_bec5262a: 'ConfirmDeletema',
    auto_112_b29a50cc: 'Order No.',
    auto_113_2ed33fd7: 'Enter order no.',
    auto_114_9e35a8d1: 'Order No.',
    auto_115_f405c3c1: 'Customer Name',
    auto_116_663fc5a0: 'Phone Number',
    auto_117_9a88cff8: 'OrderStatus',
    auto_118_5f2156c7: 'OrderAmount',
    auto_119_22bfe9e8: 'Label',
    auto_120_614faf92: 'Received Amount',
    auto_121_a8918dde: 'Source',
    auto_122_8424df51: 'Label',
    auto_123_04c07abd: 'Please selectRelated Order',
    auto_124_73595a10: 'AddorderSuccess',
    auto_125_cdc3a9b5: 'AddorderFailed',
    auto_196_28920fad: 'AddRelated Order',
    auto_276_49e87011: 'Pre-Handover',
    auto_277_559900b5: 'Formal Handover',
    auto_278_02996a1b: 'Free',
    auto_279_8151f95b: 'Paid',
    auto_280_8bf40c6f: 'All',
    auto_281_11756870: 'All',
    auto_282_7b521f16: 'Normal',
    auto_283_75ad529e: 'Close',
    auto_284_9c819402: 'Label',
    auto_285_9410be07: 'Label',
    auto_286_4cc3908f: 'Label',
    auto_287_2550957c: 'Label',
    auto_288_e37692b0: 'Five Star',
    auto_289_878f2569: 'Participate',
    auto_290_9b350bbe: 'Not Participate',
    auto_38_180ac681: 'Label',
    auto_39_0b7230fe: 'Label',
    auto_40_5b58412b: 'zuo xiName',
    auto_41_a919f418: 'Customer Name',
    auto_42_8f957442: 'Call Type',
    auto_43_f2bd5c17: 'Caller No.',
    auto_44_d4347792: 'Callee No.',
    auto_45_db33ce18: 'Call Start Time',
    auto_46_c75c29df: 'Record Duration',
    auto_47_587d26e7: 'tong huaType',
    auto_48_8c6c4a35: 'suo shuCampus',
    auto_185_cb19c98d: 'Operation',
    auto_186_f29dba85: 'Play Recording',
    auto_187_bcbca59e: 'tong huaDetail',
    callRecordPlay: 'Play Recording',
    callRecordDownload: 'Download',
    callRecordView: 'View',
    callRecordCallerNo: 'Caller Number',
    callRecordSeatName: 'Agent Name',
    callRecordDuration: 'Recording Duration',
    callRecordBeginTime: 'Call Start Time',
    callRecordEndTime: 'Call End Time',
    callRecordRecording: 'Recording',
    callRecordClose: 'Close',
    auto_263_a3b6a9bc: 'RefundAmountyuan',
    auto_264_67741fc6: 'Refund Account',
    auto_265_4ae61fb3: 'Payment Time',
    auto_266_63874e88: 'Remark',
    auto_267_783e817b: 'LatestUpdate Time',
    auto_268_2347c24e: 'Modifier',
    auto_269_09321a7d: 'zui da keUploaddeFile',
    auto_270_9984b6ef: 'Attachment',
    auto_271_dbf93436: 'DeleteSuccess',
    auto_272_bd6d52ad: 'DeleteFail',
    auto_273_f75f0221: 'EditRefund',
    auto_274_78e87cf1: 'Saved successfully',
    auto_275_58b44f9d: 'Save failed',
    auto_319_b5c748a3: 'Select province/city/district',
    auto_320_b9a08a75: 'School Name',
    auto_321_cd47f867: 'Province/City/District',
    auto_322_15891a67: 'CampusAddress',
    auto_323_a7e1165c: 'Label',
    auto_324_92e5c7c2: 'Boarding Status',
    auto_325_e3634a0c: 'Schoolren shu',
    auto_326_b83f30fc: 'Stage',
    auto_327_e42f2bff: 'Grade',
    auto_328_4ef0d893: 'Label',
    auto_329_740e298a: 'Schoolgai kuang',
    auto_330_30fe95d6: 'Remark',
    auto_188_cac3a089: 'AgentInformation',
    auto_189_eab0ff50: 'Output',
    auto_431_23df5e03: 'Label',
    auto_432_703e94d8: 'Label',
    auto_433_a108eb61: 'Label',
    auto_434_7ddc00bb: 'xinCourseban',
    auto_435_74cfb7b5: 'Nationwideshao er ban',
    auto_436_a1f0c349: 'Saved successfully',
    auto_437_e6edfae2: 'Save failed',
    auto_240_893162b1: 'Individual',
    auto_241_a237174e: 'Unchanged',
    auto_242_85503de6: 'Changed',
    auto_243_37bf8510: 'Download',
    auto_244_62fa2777: 'Campus',
    auto_245_de16923c: 'ContractAmountyuan',
    auto_246_188ae155: 'dang yueConfirmshou ruAmountyuan',
    auto_247_22e2b63a: 'RefundAmountyuan',
    auto_248_590b290c: 'Released Campus',
    auto_169_2c7d8afe: 'ContactInformation',
    auto_170_c8cc4c47: 'AddContact',
    auto_171_867dd28b: 'Upload Attachment',
    auto_172_491a2d5f: 'ConfirmDeletema',
    auto_442_d6e7c8a2: 'DeleteSuccess',
    auto_443_436832b0: 'DeleteFail',
    auto_444_1931dd78: 'ContactSaved successfully',
    auto_445_871c454b: 'ContactSave failed',
    auto_194_9e9d1b6f: 'Upload Material',
    auto_195_095a07bf: 'ConfirmDeletema',
    auto_331_64754897: 'Material Type',
    auto_332_cca45631: 'Material Name',
    auto_333_ab3aa04c: 'Remark',
    auto_334_c7ffc3f0: 'UploadTime',
    auto_335_3661a727: 'Uploader',
    auto_1_524f619a: 'On Shelf',
    auto_2_0df5a83d: 'Off Shelf',
    auto_3_731368ac: 'Login Page Float',
    auto_4_262a7a65: 'Full Screen Popup',
    auto_5_7f7109d1: 'Mini Program Home',
    auto_6_a6237381: 'Mini Program Squirrel Cup',
    auto_291_d12fd0e7: 'Free',
    auto_292_e28127d9: 'Paid',
    auto_293_5dff9970: 'Normal',
    auto_294_99839585: 'Close',
    auto_295_bd838fc3: 'Participate',
    auto_296_39578ded: 'Not Participate',
    auto_190_813ee734: 'Campus Device Info',
    auto_191_4824d9ee: 'Output',
    auto_460_0e4dcbb3: 'Label',
    auto_461_b5d06640: 'Campus Device InfoSaved successfully',
    auto_462_f02bd24c: 'Campus Device InfoSave failed',
    auto_192_56f8e083: 'Textbook Version Info',
    auto_193_fd5bfded: 'Output',
    auto_455_75c2b4bf: 'Label',
    auto_456_62d92b1b: 'CampusTextbook Version InfoSave',
    auto_457_4ad177e2: 'CampusTextbook Version InfoSave',
    auto_438_ea155344: 'Login Page Float',
    auto_439_36afcba3: 'Full Screen Popup',
    auto_440_07489eb9: 'Mini Program Home',
    auto_441_2ca7ae28: 'Mini Program Squirrel Cup',
    auto_451_3cde6d96: 'File',
    auto_452_bca81947: 'DownloadFail',
    auto_453_24a8e239: 'DeleteSuccess',
    auto_454_d68509b8: 'DeleteFail',
    auto_446_3a5e69f5: 'Public',
    auto_447_4f0ebfbd: 'Private',
    auto_448_7d07537e: 'International',
    auto_458_ce7a7f2d: 'Idle',
    auto_459_43bd0c5e: 'Busy',
    auto_449_8e4ae13d: 'Activated',
    auto_450_e46607fd: 'Not Activated',
    auto_197_950038b1: 'Backnbspnbsp',
    auto_198_945e0f9a: 'Label',
    orgSupport: 'Support',
    orgCampusDetailAddress: 'Campus Detail Address',
    orgSupportHandoverTime: 'Support Handover Time',
    orgPlannedOpeningTime: 'Planned Opening Time',
    orgActualOpeningTime: 'Actual Opening Time',
    orgCampusAccountStatus: 'Campus Account Status',
    orgReason: 'Reason',
    orgChargePlan: 'Charging Plan',
    orgFreePeriod: 'Fee-free Period',
    orgPricingCoefficient: 'Pricing Coefficient',
    orgOnlineOfflineLinkageStatus: 'Online/Offline Linkage Status',
    orgHeadOfficeOnlinePayment: 'Head Office Online Payment',
    orgAutoRechargeDeductionRatio: 'Auto Recharge Deduction Ratio',
    orgMerchant: 'Merchant',
    orgMerchantNo: 'Merchant No.',
    orgDailyClaimLimit: 'Daily Claim Limit',
    orgDailyPhoneViewLimit: 'Daily Phone View Limit',
    orgPrimaryPricing: 'Primary Pricing',
    orgJuniorPricing: 'Junior Pricing',
    orgHighPricing: 'Senior Pricing',
    orgPrimaryOriginalPricing: 'Primary Original Pricing',
    orgJuniorOriginalPricing: 'Junior Original Pricing',
    orgHighOriginalPricing: 'Senior Original Pricing',
    orgPerClassHour: 'class hour',
    orgFrontDeskPhone: 'Front Desk Phone',
    orgCampusArea: 'Campus Area',
    orgSquareMeter: 'm²',
    orgClassroomCount: 'Classroom Count',
    orgMaxCapacity: 'Maximum Capacity',
    orgUnitPiece: '',
    orgUnitPeople: '',
    orgAnnualRent: 'Annual Rent',
    orgMonthlyRent: 'Monthly Rent',
    orgDecorationStatus: 'Decoration Status',
    orgDecorationTime: 'Decoration Period',
    orgConsignee: 'Consignee',
    orgConsigneeContact: 'Consignee Contact',
    orgShippingAddress: 'Shipping Address',
    orgInvoiceTitle: 'Invoice Title',
    orgTaxpayerId: 'Taxpayer ID',
    orgAddress: 'Address',
    orgPhone: 'Phone',
    orgBank: 'Bank',
    orgBankAccount: 'Bank Account',
    orgComputer: 'Computer',
    orgPhoneDevice: 'Phone Device',
    orgIdCardPunch: 'ID Punch Machine',
    orgWritingTablet: 'Writing Tablet',
    text09i2: 'Admissions phone:',
    text0cti: 'Max capacity:',
    text1ewz: 'Action',
    text1r1i: 'Payout status:',
    text1trb: 'Equity amount:',
    text20hu: 'Click to view',
    text2vrw: 'Preparation period:',
    text3hl2: 'Export contract',
    text3i71: 'Site selection staff:',
    text3lej: 'Conversion option:',
    text3pv0: 'Contract attachment',
    text3qfo: 'Invoice title:',
    text400w: 'Payout installment:',
    text4qds: 'Address:',
    text4r3a: 'Contact email:',
    text57ze: 'Merchant:',
    text5ckl: 'Contact:',
    text5nzv: 'Refund installment:',
    text73j3: 'Reason:',
    text79cm: 'Multi-campus query',
    text7ghw: 'Pricing coefficient:',
    text7o9x: 'Bank:',
    text8egi: 'Signed district name:',
    text8f1k: 'Change details',
    text9onf: 'Contact name:',
    text9tck: 'Support staff:',
    textb0ke: 'Order info',
    textb1gv: 'Writing tablet:',
    textb2a3: 'Actual refund amount:',
    textbccd: 'Area release',
    textbg1j: 'Organization info',
    textbs5c: 'Refund reason:',
    textcfk1: 'Contact:',
    textdy3e: 'Amount received:',
    texte7q0: 'Organization tags:',
    texteb59: 'Bank:',
    textf5ni: 'Signing deposit:',
    textf5wl: 'Charge status:',
    textfhfp: 'Organization type:',
    textfpkt: 'Attachments:',
    textgdcv: 'Invoice info',
    textgk5w: 'Other signed documents',
    textgq47: 'Refund method:',
    textgw9t: 'Auto recharge deduction ratio:',
    texthi1b: 'Signer contact address:',
    texthuk5: 'Contract status:',
    texti3gp: 'Organization area:',
    textiawl: 'Total refund amount:',
    textitua: 'Enable large class',
    textj8iv: 'Sign amount:',
    textkcim: 'Release status:',
    textkl00: 'Location:',
    textkw0m: 'Organization rating:',
    textkwte: 'Refund info',
    textkxu2: 'Organization nature:',
    textln8s: 'Classrooms:',
    textm843: 'Phone:',
    textmbem: 'Signing entity change status:',
    textmiqa: 'Multi-campus:',
    textnevv: 'Contract manager:',
    textnfdt: 'Camera:',
    textng46: 'Account type:',
    textngln: 'Contact info',
    textoe85: 'Organization name:',
    textp4vn: 'Discount contract:',
    textptcu: 'Opening status:',
    textpwah: 'Admissions email:',
    textq675: 'Organization equipment',
    textql7m: 'Consignee:',
    textqsri: 'Commission-free period:',
    textr4ty: 'Enable small class',
    textrpyp: 'HQ online payment:',
    textryvf: 'Contact email:',
    texts3x4: 'Textbook versions',
    textshon: 'Full name:',
    textsnnc: 'Organization address:',
    textt9pg: 'Charge plan:',
    texttesz: 'Signing entity:',
    textthsl: 'Organization entity',
    texttl4e: 'Prefecture-level standard:',
    texttnu6: 'Contact phone:',
    texttvx2: 'Campus tags:',
    textu21u: 'Legal person name:',
    textu2w0: 'Payout status:',
    textu8yx: 'Computer:',
    textuag3: 'Payout info',
    textug2a: 'Shipping address:',
    textuwlj: 'Prefecture standard note:',
    textvj4l: 'Campus after release',
    textvmez: 'Business license attachment:',
    textvz77: 'Market subsidy fee:',
    textwfvm: 'Materials',
    textwkrh: 'Organization basic info',
    textwr4i: 'Deduction amount:',
    textxgbj: 'Handover status:',
    textxquz: 'Phone device:',
    textye7k: 'Pricing and system',
    textyu3h: 'Consignee contact:',
    textzgvh: 'Pick coordinates',
    textzp3y: 'Decoration status:',
    orgCamera: 'Camera',
    smallsmall: 'Small class, primary original price:',
    smallmiddle: 'Small class, junior original price:',
    smallhighmiddle: 'Small class, senior original price:',
    bigsmall: 'Large class, primary price:',
    bigmiddle: 'Large class, junior price:',
    bighighmiddle: 'Large class, senior price:',
    yihour: 'First payout time:',
    er: 'Second payout amount:',
    yi: 'First payout amount:',
    erhour: 'Second payout time:',
    backhour: 'Last payment time:',
    backyihour: 'Last payout time:',
    backyi: 'Last payout amount:',
    textContractPeriod: 'Contract period:',
    textSignTime: 'Sign time:',
    textGiveDeduct: 'Gift deduction:',
    textAccountDeductAmt: 'Account deduction:',
    textBizLicenseNo: 'Business license no.:',
    textIdCardNo: 'ID number:',
    textTermAgreementTime: 'Termination agreement time:',
    textTermAgreementEntryTime: 'Termination agreement recorded time:',

  }
};
